import { fetchApi } from '@/config/axiosSetting';
import { PatchBodyPartOneVehicleInformationType } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyPartOneVehicleInformation/patchBodyPartOneVehicleInformation.type';

export const patchBodyPartOneVehicleInformationFunction = ({
  id,
  data,
}: PatchBodyPartOneVehicleInformationType) => {
  return fetchApi.patch(`/body/reports/${id}/vehicle_information/part_one/`, {
    ...data,
  });
};
